module.exports = __webpack_public_path__ + "img/70.6edfd842.svg";